module.exports = __webpack_public_path__ + "img/welfare-item-bg.7bfa530c.png";